module.exports = new __parcel__URL__("feature-4.1fba987b.png").toString();